var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout-basic',[_c('h3',{staticClass:"title is-4"},[_vm._v("Dashboard")]),_c('p',[_vm._v("No widgets yet")])])}
var staticRenderFns = []

export { render, staticRenderFns }